import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['email', 'listId', 'formId', 'originKey', 'lang', 'message', 'loadingSpinner'];

  async subscribe(event) {
    event.preventDefault();

    // Collect the CSRF token, email, and listId
    const csrfTokenName = this.element.dataset.csrfName;
    const csrfTokenValue = this.element.dataset.csrfValue;
    const email = this.emailTarget.value;
    const listId = this.listIdTarget.value;
    const formId = this.formIdTarget.value;
    const originKey = this.originKeyTarget.value;
    const lang = this.langTarget.value;
    this.showLoadingSpinner();

    if (!email) {
      this.hideLoadingSpinner();
      this.showMessage('Please provide a valid email.', false);
      return;
    }
    if (!listId || !formId) {
      this.hideLoadingSpinner();
      this.showMessage('There was a problem.', false);
      return;
    }

    const formData = new FormData();
    formData.append('email', email);
    formData.append('listId', listId);
    formData.append('formId', formId);
    formData.append('originKey', originKey);
    formData.append('lang', lang);
    formData.append(csrfTokenName, csrfTokenValue);

    try {
      // Get access token before subscribing
      let tokenResponse = await fetch('/cleverreach/get-access-token');
      let tokenData = await tokenResponse.json();

      if (!tokenData.success) {
        this.hideLoadingSpinner();
        this.showMessage('Error retrieving access token: ' + tokenData.error, false);
        return;
      }

      const accessToken = tokenData.access_token;
      formData.append('access_token', accessToken); // Add access token to form data

      // Subscribe user
      let response = await fetch('/cleverreach/subscribe', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      let data = await response.json();
      this.hideLoadingSpinner();
      this.showMessage(data.success ? data.message : 'Error: ' + data.error, data.success);
      if (data.success) {
        this.element.reset();
      }
    } catch (error) {
      this.hideLoadingSpinner();
      console.error('Error:', error);
      this.showMessage('An error occurred. Please try again.', false);
    }
  }

  showMessage(message, isSuccess) {
    this.messageTarget.style.display = 'block';
    this.messageTarget.textContent = message;
  }

  showLoadingSpinner() {
    if (this.hasLoadingSpinnerTarget) {
      this.loadingSpinnerTarget.style.display = 'block';
    }
  }

  hideLoadingSpinner() {
    if (this.hasLoadingSpinnerTarget) {
      this.loadingSpinnerTarget.style.display = 'none';
    }
  }
}
